<template>
  <div
    class="d-flex align-items-center get-credit-insights-access_container"
    data-test-get-credit-insights-access
  >
    <div class="d-flex flex-column credit-insights-image i-m-6">
      <img
        src="../../img/barchart_and_piechart.svg"
        class=""
        alt="barchart and piechart"
      />
    </div>

    <div class="d-flex i-my-6 i-ml-9 i-mr-11 justify-content-between w-100">
      <div class="d-flex flex-column p-10 flex-grow-1">
        <h6 class="i-text-heading-6 i-text-neutral-120">
          Want exclusive access to Credit Insights?
        </h6>
        <p class="i-text-body-2 i-text-neutral-110">
          Make fast, accurate, and fair underwriting decisions with access to
          credit insights from bank statements and open banking data
        </p>
      </div>
      <div class="d-flex align-items-center">
        <i-button
          text="Request access"
          size="md"
          aria-label="Request access to Credit Insights"
          data-testid="credit-insights-available-button"
          @button-click="onClickGetCreditInsightsAccess()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { iButton } from '@inscribe/signal';

export default {
  components: {
    iButton,
  },
  props: {},
  methods: {
    onClickGetCreditInsightsAccess() {
      this.navigateToMarketingWebsiteFeatureSignUpPage();
    },
    navigateToMarketingWebsiteFeatureSignUpPage() {
      window.location.href = 'https://www.inscribe.ai/feature-sign-up';
    },
  },
};
</script>

<style lang="scss" scoped>
.get-credit-insights-access_container {
  display: flex;
  min-height: 100px;
  align-items: center;
  border-radius: 16px;
  border: 1px solid $light-neutral-60;
  background: $color-white;
  margin: 16px 0 -32px 0;

  .credit-insights-image {
    width: 140px;
    height: 76px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: $light-primary-30;
  }

  p {
    max-width: 446px;
  }
}
</style>
